/* Der Vorschlag vom letzten Mal, angeglichen (08.10.2026) — rein und ohne
   Klient, damit er sich ohne Browser prüfen lässt. Der Weg dazu steht in
   `daten/letztemenge.ts`. */

type Roh = Record<string, unknown>;

export type Mengenvorschlag = {
  menge: number;
  /** Woher die Zahl kommt: erfasst, gemessen (Aufmaß ohne Auftrag), geplant. */
  quelle: "ist" | "plan" | "aufmass";
  /** Die Vorgangsnummer — leer bei einem Aufmaß ohne Auftrag. */
  nr: string;
  /** `JJJJ-MM-TT`. */
  datum: string;
  /** Der Einsatzort von damals — leer: keiner. */
  ort: string;
  /** War es am gefragten Einsatzort? */
  amOrt: boolean;
  /** Der Grad von damals — leer: keiner bekannt. */
  kategorieId: string;
};

/** Rein, damit es sich ohne Browser prüfen lässt. */
export function alsMengenvorschlag(roh: unknown): Mengenvorschlag | null {
  if (!roh || typeof roh !== "object") return null;
  return einVorschlag((roh as Roh)["vorschlag"]);
}

/**
 * **Die früheren Werte** (Paket aufnahmen2) — `frueher` aus
 * `GET /merkliste/zuletzt`, am Ort zuerst, dann die jüngste. Fehlt die Liste
 * (ältere API), steht der Vorschlag allein darin.
 */
export function alsFruehereMengen(roh: unknown): Mengenvorschlag[] {
  if (!roh || typeof roh !== "object") return [];
  const liste = (roh as Roh)["frueher"];
  if (!Array.isArray(liste)) {
    const einer = alsMengenvorschlag(roh);
    return einer ? [einer] : [];
  }
  return liste.map(einVorschlag).filter((x): x is Mengenvorschlag => x !== null);
}

/** Die Quelle als Wort am Feld: „aus Ortsaufnahme 12.10." bzw. „aus V-2026-0002". */
export function quellenwort(
  v: Mengenvorschlag,
  t: (k: string, w?: Record<string, string | number>) => string,
  tagKurz: (tag: string) => string,
): string {
  return v.nr
    ? t("merkliste.mengeAusVorgang", { nr: v.nr })
    : t("merkliste.mengeAusAufnahme", { datum: v.datum ? tagKurz(v.datum) : "" });
}

function einVorschlag(v: unknown): Mengenvorschlag | null {
  if (!v || typeof v !== "object") return null;
  const x = v as Roh;
  const menge = typeof x["menge"] === "number" ? x["menge"] : Number(x["menge"]);
  if (!Number.isFinite(menge) || menge <= 0) return null;
  const quelle = x["quelle"] === "ist" || x["quelle"] === "aufmass" ? x["quelle"] : "plan";
  const txt = (w: unknown): string => (typeof w === "string" ? w : "");
  return {
    menge,
    quelle,
    nr: txt(x["nr"]),
    datum: txt(x["datum"]),
    ort: txt(x["ort"]),
    amOrt: x["am_ort"] === true,
    kategorieId: txt(x["kategorie_id"]),
  };
}
